'use client';
import { basePageConfig } from '@castlery/config';
import type { OrderHistoryItem } from '@castlery/modules-order-domain';
import { useParams } from 'next/navigation';

export function getProductLink(slug: string) {
  return `${basePageConfig.product}/${slug}`;
}

export function getVariantLink(variant: OrderHistoryItem['variant']) {
  let link = getProductLink(variant.productSlug);
  if (!link) {
    return null;
  }

  if (variant.variantOptionValues !== undefined) {
    const variantQueryArr = variant.variantOptionValues.map((option) => `${option.optionTypeName}=${option.name}`);

    const query = variantQueryArr.join('&');

    if (query) {
      link += `?${query}`;
    }
  }

  return link;
}

export function useLineItemLink(item: OrderHistoryItem) {
  const { region } = useParams();
  let link = getVariantLink(item.variant);

  if (link && item.productType === 'bundle') {
    const queryArr = item.bundleLineItems
      ?.filter((i) => i.variant)
      .map((i) => `${i.bundleOption.bundleOptionName ?? ''}=${i.variant.id}`);
    const query = queryArr?.join('&');
    link = `${link}?${query}`;
  }

  return `/${region}${link}`;
}
